import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import FilledInput from "@material-ui/core/FilledInput";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import Switch from "@material-ui/core/Switch";
// @material-ui/icons components
import CreditCard from "@material-ui/icons/CreditCard";
import Event from "@material-ui/icons/Event";
import Lock from "@material-ui/icons/Lock";
import Person from "@material-ui/icons/Person";
// core components
import hexToRgb from "assets/theme/hex-to-rgb.js";

export default function CardCreditInputs() {
  const theme = useTheme();
  return (
    <>
      <Card
        sx={{
          background:
            "linear-gradient(87deg," +
            theme.palette.primary.main +
            ",#825ee4)!important",
        }}
      >
        <CardContent>
          <Grid
            container
            component={Box}
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Grid item xs="auto">
              <Box
                component="img"
                sx={{ verticalAlign: "center", borderStyle: "none" }}
                src={require("assets/img/icons/cards/mastercard.png").default}
                alt="..."
              ></Box>
            </Grid>
            <Grid item xs="auto">
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  component="small"
                  sx={{
                    fontSize: "80%",
                    fontWeight: "600",
                    marginRight: "1rem",
                    color: theme.palette.white.main,
                  }}
                >
                  Make default
                </Box>
                <Switch name="checkedA" defaultChecked color="white" />
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ marginTop: "1.5rem" }}>
            <FormControl
              variant="filled"
              component={Box}
              sx={{ width: "100%", marginBottom: "1rem!important" }}
            >
              <FilledInput
                autoComplete="off"
                type="text"
                placeholder="Name on card"
                sx={{
                  backgroundColor:
                    "rgba(" +
                    hexToRgb(theme.palette.primary.inputCredit) +
                    ",.5) !important",
                  "& .MuiFilledInput-input": {
                    backgroundColor:
                      theme.palette.transparent.main + "!important",
                    color: theme.palette.white.main + "!important",
                  },
                }}
                startAdornment={
                  <InputAdornment
                    position="start"
                    sx={{
                      backgroundColor:
                        theme.palette.transparent.main + "!important",
                      color: theme.palette.white.main,
                    }}
                  >
                    <Person />
                  </InputAdornment>
                }
              />
            </FormControl>
            <FormControl
              variant="filled"
              component={Box}
              sx={{ width: "100%", marginBottom: "1rem!important" }}
            >
              <FilledInput
                autoComplete="off"
                type="text"
                placeholder="Card number"
                sx={{
                  backgroundColor:
                    "rgba(" +
                    hexToRgb(theme.palette.primary.inputCredit) +
                    ",.5) !important",
                  "& .MuiFilledInput-input": {
                    backgroundColor:
                      theme.palette.transparent.main + "!important",
                    color: theme.palette.white.main + "!important",
                  },
                }}
                startAdornment={
                  <InputAdornment
                    position="start"
                    sx={{
                      backgroundColor:
                        theme.palette.transparent.main + "!important",
                      color: theme.palette.white.main,
                    }}
                  >
                    <CreditCard />
                  </InputAdornment>
                }
              />
            </FormControl>
            <Grid container>
              <Grid item xs={6}>
                <FormControl
                  variant="filled"
                  component={Box}
                  sx={{ width: "100%", marginBottom: "1rem!important" }}
                >
                  <FilledInput
                    autoComplete="off"
                    type="text"
                    placeholder="MM/YY"
                    sx={{
                      backgroundColor:
                        "rgba(" +
                        hexToRgb(theme.palette.primary.inputCredit) +
                        ",.5) !important",
                      "& .MuiFilledInput-input": {
                        backgroundColor:
                          theme.palette.transparent.main + "!important",
                        color: theme.palette.white.main + "!important",
                      },
                    }}
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{
                          backgroundColor:
                            theme.palette.transparent.main + "!important",
                          color: theme.palette.white.main,
                        }}
                      >
                        <Event />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  variant="filled"
                  component={Box}
                  sx={{ width: "100%", marginBottom: "1rem!important" }}
                >
                  <FilledInput
                    autoComplete="off"
                    type="text"
                    placeholder="Card number"
                    sx={{
                      backgroundColor:
                        "rgba(" +
                        hexToRgb(theme.palette.primary.inputCredit) +
                        ",.5) !important",
                      "& .MuiFilledInput-input": {
                        backgroundColor:
                          theme.palette.transparent.main + "!important",
                        color: theme.palette.white.main + "!important",
                      },
                    }}
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{
                          backgroundColor:
                            theme.palette.transparent.main + "!important",
                          color: theme.palette.white.main,
                        }}
                      >
                        <Lock />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Button variant="contained" color="info" fullWidth>
              Save new card
            </Button>
          </Box>
        </CardContent>
      </Card>
    </>
  );
}
